import React from 'react';

export const CheckFull = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 21.43c5.799 0 10.5-4.701 10.5-10.5 0-5.8-4.701-10.5-10.5-10.5S.5 5.13.5 10.93c0 5.799 4.701 10.5 10.5 10.5Zm5.596-13.677a.9.9 0 0 0-1.273.019l-5.235 5.391-2.533-2.175-.132-.094a.9.9 0 0 0-1.04 1.46l2.962 2.543.137.102a1.2 1.2 0 0 0 1.506-.176l5.627-5.798.102-.126a.9.9 0 0 0-.121-1.146Z"
      clipRule="evenodd"
    />
  </svg>
);
